import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { PosAddGiftcardModalService } from 'src/app/@core/services/pos-add-giftcard-modal.service';
import { PosFloatingActionButtonService } from 'src/app/@core/services/pos-floating-action-button.service';
import { ColumnTable } from 'src/app/models/column-table';
import { Discount } from 'src/app/models/discount';
import { Order } from 'src/app/models/order';
import { Paging } from 'src/app/models/page';
import { ProductCart } from 'src/app/models/product-cart';
import { OrderRequest } from 'src/app/models/requests/order-request';
import { CustomerTableModel } from 'src/app/models/table-models/customer-table';
import { Tax } from 'src/app/models/tax';
import { TaxExemption } from 'src/app/models/tax-exemption';
import { AuthService } from 'src/app/services/auth.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { OrderService } from 'src/app/services/order.service';

@Component({
  selector: 'gifcard-cart-step',
  templateUrl: './giftcard-cart-step.component.html',
  styleUrls: ['./giftcard-cart-step.component.sass']
})
export class GiftcardCartStepComponent implements OnInit {

  @Input() orderSimulate: Order = new Order();
  @Input()
  productsCart: Paging<Array<ProductCart>> = new Paging([]);

  @Input()
  customer: CustomerTableModel = new CustomerTableModel();

  private seller: CustomerTableModel = new CustomerTableModel();

  orderRequest: OrderRequest = new OrderRequest();

  @Output()
  getOrder = new EventEmitter<{
    order: Order;
    orderRequest?: OrderRequest;
    productsCart: Paging<Array<ProductCart>>;
  }>();

  @Output()
  getTableFormExternal = new EventEmitter();

  private taxes: Array<Tax> = [];
  @Output()
  changeGiftcardValue: EventEmitter<boolean> = new EventEmitter();
  constructor(private orderService: OrderService, private configService: ConfigurationService, private authService: AuthService, private floatingService: PosFloatingActionButtonService, private giftcardModalService: PosAddGiftcardModalService) {

    this.floatingService.setActions([{
      id: "addProduct",
      fn: async () => {
        await this.giftcardModalService.show(new ProductCart(), this.orderSimulate, (product: ProductCart) => {
          product.code = this.getOrderEntryCode(this.productsCart.content);
          this.productsCart.content.push(product);
          this.productsCart = new Paging(this.productsCart.content);
          this.changeGiftcardValue.emit(true);
        });
      },
      icon: "fa-gift",
      tooltip: "Agregar Producto"
    }]);
    this.floatingService.setShow(false);
    this.floatingService.addItems();
  }

  ngOnInit(): void {
    this.seller.code = this.authService.readProfileInStorage().username;
    this.seller.fullName = this.authService.readProfileInStorage().fullname;
  }

  getProductCartHeaders(): Array<ColumnTable> {
    return [
      new ColumnTable('code', 'Opciones', {
        type: 'action',
        actions: [
          {
            fn: async (val: ProductCart) => {
              await this.removeProductCart(val);
            },
            icon: 'fa fa-times text-danger',
            isDisabled: false,
            tooltip: 'Eliminar Producto',
          },
          {
            fn: async (val: ProductCart) => {
              await this.changePrice(val);
            },
            icon: 'fa fa-pencil',
            isDisabled: false,
            tooltip: 'Editar',
          }
        ],
        iconClass: 'fa fa-cogs',
        isIcon: true,
      }),
      new ColumnTable('amount', '#', {
        type: 'number',
        isIcon: true,
        iconClass: 'fa fa-shopping-cart',
        editable: false,
        required: true,
      }),
      new ColumnTable('productCode', 'Código'),
      new ColumnTable('description', 'Descripción'),
      new ColumnTable('serial', 'Numero de Tarjeta'),
      new ColumnTable('price', 'Total', { type: 'currency' }),
      new ColumnTable('discountTotal', 'Descuento', { type: 'hidden' }),
      new ColumnTable('total', '', { type: 'hidden' }),
      new ColumnTable('taxCode', '', { type: 'hidden' }),
      new ColumnTable('originalTaxCode', '', { type: 'hidden' }),
      new ColumnTable('requiredSerial', '', { type: 'hidden' }),
      new ColumnTable('discount', '', { type: 'hidden' }),
      new ColumnTable('discount2', '', { type: 'hidden' }),
      new ColumnTable('referenceCode', '', { type: 'hidden' }),
      new ColumnTable('isDelivery', '', { type: 'hidden' }),
      new ColumnTable('deliveryBranchCode', '', { type: 'hidden' }),
      new ColumnTable('features', '', { type: 'hidden' }),
      new ColumnTable('hasExtraWarrantyAdded', '', { type: 'hidden' }),
      new ColumnTable('comboSetCode', '', { type: 'hidden' }),
      new ColumnTable('associatedOrder', '', { type: 'hidden' }),
      new ColumnTable('associatedOrderEntry', '', { type: 'hidden' }),
      new ColumnTable('associatedSerialNumber', '', { type: 'hidden' }),
      new ColumnTable('extraWarrantyInvoiceCode', '', { type: 'hidden' }),
      new ColumnTable('extraWarrantyInvoiceLine', '', { type: 'hidden' }),
      new ColumnTable('serviceType', '', { type: 'hidden' }),
      new ColumnTable('isService', '', { type: 'hidden' }),
      new ColumnTable('comboProduct', '', { type: 'hidden' }),
      //new ColumnTable("price", "", "hidden"),
    ];
  }

  async saveProductCart(table: Array<ProductCart>): Promise<void> {
    await this.getOrderFromServer(table);
    this.productsCart.content = table;
  }

  private async getOrderFromServer(table: ProductCart[]) {
    const orderRequest = new OrderRequest().buildOrderRequest(
      table,
      this.taxes,
      this.customer,
      this.seller,
      this.configService.readSelectedBranchAndSalesOrg().branch.code,
      this.configService.readSelectedBranchAndSalesOrg().salesOrg.code,
      new TaxExemption(),
      new Discount(),
      [],
      this.configService.readPhysicalEstablishment().code,
      "",
      this.orderSimulate.orderType,
      this.orderSimulate.status,
      undefined,
      undefined,
      this.orderSimulate.procedureId,
      this.orderSimulate.preapproveCode,
      undefined,
      undefined,
    );

    this.orderRequest = orderRequest;

    const orderFromServer = (
      await this.orderService.createOrderSimulate(orderRequest).toPromise()
    ).response;


    this.orderSimulate = orderFromServer;



    this.getOrder.emit({
      order: this.orderSimulate,
      productsCart: new Paging(table),
      orderRequest: this.orderRequest,
    });
  }

  async removeProductCart(product: ProductCart) {
    this.productsCart = new Paging<ProductCart[]>(this.productsCart.content.filter((f) => f.code != product.code));
    this.changeGiftcardValue.emit(true);
  }

  async changePrice(val: ProductCart): Promise<void> {
    await this.giftcardModalService.show(val, this.orderSimulate, (product: ProductCart) => {
      this.productsCart = new Paging(this.productsCart.content);
      this.changeGiftcardValue.emit(true);
    }, true)

  }

  getTableForm(tableForm: FormGroup) {
    this.getTableFormExternal.emit(tableForm);
  }

  getOrderEntryCode(productsCart: ProductCart[]): number {
    if (productsCart.length == 0) {
      return 1;
    }
    let maxCode = Math.max(...productsCart.map(m => m.code));
    return maxCode + 1;
  }
}
